import * as React from 'react'
import { IconsModel } from './iconsModel'

function SvgAdministrative(
	{
		color,
		width = 50,
		height = 50
	}: IconsModel
) {
	return (
		<svg width={width} height={height} viewBox="0 0 50 50">
			<path
				fill={color}
				fillRule="evenodd"
				d="M41.81 1c.368 0 .672.274.72.629l.007.098V25a.726.726 0 01-1.447.099L41.082 25V2.455H4.454v45.09h16.298c.369 0 .673.274.721.629l.007.099a.727.727 0 01-.629.72l-.099.007H3.727a.727.727 0 01-.72-.629L3 48.273V1.727c0-.368.274-.672.629-.72L3.727 1H41.81zM29.215 49a.727.727 0 01-.727-.727V37.694a.73.73 0 01.29-.582l8.464-6.347a.726.726 0 01.872 0l8.463 6.347a.729.729 0 01.291.582v10.579a.728.728 0 01-.727.727zm8.462-16.745l-7.735 5.802v9.487h7.008v-3.503a.728.728 0 011.448-.098l.007.098v3.503h7.008v-9.487l-7.736-5.802zm-16.925 2.596a.728.728 0 01.099 1.448l-.099.007H12.29a.728.728 0 01-.099-1.448l.099-.007h8.462zm12.595-10.578a.726.726 0 01.099 1.447l-.099.007H12.29a.727.727 0 01-.099-1.447l.099-.007h21.057zm0-10.579a.727.727 0 01.099 1.448l-.099.007H12.29a.728.728 0 01-.099-1.448l.099-.007h21.057z"
			/>
		</svg>
	)
}

export default SvgAdministrative
